<template>

  <v-row>
    <v-col class="st" cols="12" sm="3">
      <v-text-field :label="$t('booking.user_info.user.first_name_label')" required v-model="person.prenom"
      ></v-text-field>
    </v-col>
    <v-col class="st" cols="12" sm="3">
      <v-text-field :label="$t('booking.user_info.user.last_name_label')" required v-model="person.nom"
      ></v-text-field>
    </v-col>
    <v-col class="st" cols="12" sm="3">
      <v-text-field :label="$t('booking.user_info.user.email_label')" v-model="person.email"
                    type="email" :rules="[v => !!v || $t('shared.emailRequired')]"
      ></v-text-field>
    </v-col>

    <v-col class="st" cols="12" sm="2" v-if="isUploadFile">

      <v-file-input counter show-size accept="image/*;capture=camera" @change="onFileChange" ref="fileUpload"
                    :label="$t('client.account.license')" prepend-icon="mdi-camera"></v-file-input>
      <small v-if="person.file">{{person.file.name}}</small>
    </v-col>

    <v-col class="st" cols="12" sm="1" v-if="isUploadFile">
      <v-btn class="mx-2" fab dark small color="warning" v-on:click="deleteLine()">
        <v-icon dark>mdi-delete</v-icon>
      </v-btn>
    </v-col>
  </v-row>


</template>


<script>


import moment from 'moment'
import { UsersApi } from '../services'


export default {
  name: 'PersonyForm',
  props: {
    isUploadFile: {},
    person: {},
    file: {},
    indexId :Number
  },
  data () {
    return {}
  },
  methods: {
    onFileChange (file) {

      console.log('File', file)
      if (file) {
        var fileName = file.name
        if (file.name == 'image.jpg') {
          fileName = moment().format('YYYY-MM-DD hh.mm.ss') + '.jpg'
        }
        fileName = this.uuidv4() + fileName
        this.person.fileJustForProcessing = file
        this.person.fileNameForProcessing = fileName

      }else {
        this.person.fileJustForProcessing = ""
        this.person.fileNameForProcessing = ""
      }
    },
    uuidv4 () {
      return '10000000_'.replace(/[018]/g, c =>
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      )
    },
    deleteLine () {
      console.debug("parent",this.indexId ,this.$parent);

      this.$parent.$parent.deleteLine(this.indexId);
    }
  },
  computed: {},
  mounted: function () {

  }
}
</script>
